import { CircularProgress, Dialog, DialogContent } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useWorkOrderDetail } from '../../services/business/workOrders';
import { normalizeWorkOrderStatus, WORK_ORDER_STATUS } from '../../utility/Constant';
import WorkOrderDraft from './Drafts/WorkOrderDraft';
import WorkOrderView from './View/WorkOrderView';

/**
 * Work Order detail router.
 *
 * Like InvoiceDetail, the view is chosen from the record's status rather than the url:
 *   draft                                  → WorkOrderDraft
 *   open / authorized / invoiced / cancelled → WorkOrderView
 */
const WorkOrderDetail = () => {
    const { id } = useParams();
    const { data: workOrderData, isFetching: showLoader, refetch } = useWorkOrderDetail(id);

    if (showLoader && !workOrderData) {
        return (
            <Dialog open>
                <DialogContent>
                    <CircularProgress />
                </DialogContent>
            </Dialog>
        );
    }

    if (!workOrderData) return null;

    // The API returns the legacy vocabulary (pending / approved / reauthorized), so normalise
    // before routing — see the spec, §14.4.
    const status = normalizeWorkOrderStatus(workOrderData?.status);

    if (status === WORK_ORDER_STATUS.DRAFT) {
        return <WorkOrderDraft workOrderId={id} workOrderData={workOrderData} showLoader={showLoader} fetchApi={refetch} />;
    }

    // Open / Authorized / Reapproval / Invoiced / Cancelled — and anything new the backend adds,
    // so an unrecognised status still renders the document rather than a blank page.
    return <WorkOrderView workOrderId={id} workOrderData={workOrderData} showLoader={showLoader} fetchApi={refetch} />;
};

export default WorkOrderDetail;
